/* eslint-disable no-invalid-this */
const NS = 'SiteHeaderWidget';
const CLS = 'siteHeaderWidget';

import { overlay } from '../../../../global/js/wlc/overlay';

export class SiteHeaderWidget {
    constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.overlay = overlay;

		// Main top menu (show submenu on hover)
        this.$topMenuNavDropdownButtons = this.$element.find(`.${CLS}-top-menu-nav-item.dropdown`);
		// if(this.matchMedia('(min-width: 768px)').matches) {
			this.$topMenuNavDropdownButtons.on('mouseenter mouseleave', function(event) {
				if(event.type === 'mouseenter') {
					$(this).addClass('show');
					$('.dropdown-toggle', this).attr('aria-expanded', 'true');
					$('.dropdown-menu', this).addClass('show');
				}
				else {
					$(this).removeClass('show');
					$('.dropdown-toggle', this).attr('aria-expanded', 'false');
					$('.dropdown-menu', this).removeClass('show');
				}
			});
		// }
		// else {
		// 	this.$topMenuNavDropdownButtons.off('mouseenter mouseleave');
		// }

		// Language top menu (show submenu on hover)
        this.$topMenuLanguageNavDropdownButtons = this.$element.find(`.${CLS}-top-menu-lang.dropdown`);
		// if(this.matchMedia('(min-width: 768px)').matches) {
			this.$topMenuLanguageNavDropdownButtons.on('mouseenter mouseleave', function(event) {
				if(event.type === 'mouseenter') {
					$(this).addClass('show');
					$('.dropdown-toggle', this).attr('aria-expanded', 'true');
					$('.dropdown-menu', this).addClass('show');
				}
				else {
					$(this).removeClass('show');
					$('.dropdown-toggle', this).attr('aria-expanded', 'false');
					$('.dropdown-menu', this).removeClass('show');
				}
			});
		// }
		// else {
		// 	this.$topMenuNavDropdownButtons.off('mouseenter mouseleave');
		// }

		// Search icon button (dropdown search)
        this.$searchBar = this.$element.find(`.siteHeaderSearchBarWidget`);
        this.$topSearchButton = this.$element.find(`.${CLS}-top-btn--search`);
        this.$topSearchButton.on('click', () => {
			this.$searchBar.addClass('active');
			this.$topSearchButton.addClass('active');
			this.$searchBar.trigger('siteHeaderSearchBarWidget.open', {
				siteHeaderWidget: this.$element
			});
			// this.overlay.create(() => {
			// 	this.$searchBar.removeClass('active');
			// 	this.$topSearchButton.removeClass('active');
			// });
        });

		// Search close button (dropdown search)
		this.$element.on(`${CLS}.searchBar.close`, () => {
			// this.overlay.destroy(() => {
				this.$searchBar.removeClass('active');
				this.$topSearchButton.removeClass('active');
			// });
		});

		// Profile Menu Dropdown  (submenu)
		this.$profileDropdown = this.$element.find(`.siteHeaderProfileDropdownWidget`);
		$(document.body).append(this.$profileDropdown);
		this.setProfileDropdownPosition();

		// Profile button
		this.$topAvatarButton = this.$element.find(`.${CLS}-top-btn--avatar`);
        this.$topAvatarButton.on('click', () => {
			this.$topAvatarButton.addClass('active');
			this.$profileDropdown.addClass('active');
			this.setProfileDropdownHeight();
			this.overlay.create(() => {
				this.$topAvatarButton.removeClass('active');
				this.$profileDropdown.removeClass('active');
			});
        });

		// Mobile menu toggle button (submenu)
        this.$topTogglerButton = this.$element.find(`.${CLS}-top-btn--toggler`);
        this.$topTogglerButton.on('click', () => {
			this.$topTogglerButton.addClass('active');
			this.$profileDropdown.addClass('active');
			this.overlay.create(() => {
				this.$topTogglerButton.removeClass('active');
				this.$profileDropdown.removeClass('active');
			});
        });

        // On window resize + load (with debounce)
		$(window).on('load resize', _.debounce(() => {
			// Resizes the dropdownHeight when needed
			this.setProfileDropdownPosition();
			if(this.$profileDropdown.hasClass('active')) {
                this.setProfileDropdownHeight();
            }

			// Top menu
			//
        }, 250));
    }

    setProfileDropdownHeight() {
        let offsetTop = Math.floor(this.$profileDropdown.offset().top);
        this.$profileDropdown.css({
            maxHeight: `calc(100vh - ${offsetTop}px)`
        });
    }

    setProfileDropdownPosition() {
		this.$profileDropdown.css({
			top: this.$element.offset().top + this.$element.height()
		});
	}
}
